export enum SystemId {

    Integration = 1,
    Extension = 2,
    Web = 3,
    Batch = 4,
    Postman = 5

}



// WEBPACK FOOTER //
// ./src/app/shared/enums/systemId.ts